(function() {
  'use strict';

  // ==================== Global Consent API ====================
  // Used by other scripts to check consent status and load blocked scripts
  window.pawmateConsent = {
    state: { analytics: false, marketing: false, preferences: false },
    _version: '2.0',

    hasAnalytics: function() { return this.state.analytics; },
    hasMarketing: function() { return this.state.marketing; },
    hasPreferences: function() { return this.state.preferences; },

    // Activate blocked scripts after consent
    activateBlockedScripts: function(category) {
      var scripts = document.querySelectorAll('script[type="text/plain"][data-consent="' + category + '"]');
      scripts.forEach(function(script) {
        var newScript = document.createElement('script');
        if (script.dataset.src) {
          newScript.src = script.dataset.src;
          newScript.async = true;
        } else {
          newScript.textContent = script.textContent;
        }
        script.parentNode.replaceChild(newScript, script);
      });
    },

    // Update state, activate scripts, and sync Google Consent Mode v2
    updateState: function(prefs) {
      this.state = prefs;
      if (prefs.analytics) this.activateBlockedScripts('analytics');
      if (prefs.marketing) this.activateBlockedScripts('marketing');
      if (prefs.preferences) this.activateBlockedScripts('preferences');

      // Google Consent Mode v2 update
      if (typeof gtag === 'function') {
        gtag('consent', 'update', {
          'ad_storage': prefs.marketing ? 'granted' : 'denied',
          'ad_user_data': prefs.marketing ? 'granted' : 'denied',
          'ad_personalization': prefs.marketing ? 'granted' : 'denied',
          'analytics_storage': prefs.analytics ? 'granted' : 'denied'
        });
      }


      // Click-ID storage follows marketing consent (ePrivacy art.5(3) / PKE art.399):
      //  granted -> persist; absent/withdrawn -> clear any stored copy (incl. legacy v2 leftovers).
      if (prefs.marketing) {
        if (typeof window.__pawmatePersistClickIds === 'function') window.__pawmatePersistClickIds();
      } else if (typeof window.__pawmateClearClickIds === 'function') {
        window.__pawmateClearClickIds();
      }
    }
  };

  // ==================== DOM Elements ====================
  var banner = document.getElementById('cookie-consent');
  var acceptBtn = document.getElementById('cookie-consent-accept');
  var declineBtn = document.getElementById('cookie-consent-decline');
  var settingsBtn = document.getElementById('cookie-consent-settings');

  var settingsModal = document.getElementById('cookie-settings');
  var settingsOverlay = document.getElementById('cookie-settings-overlay');
  var settingsCloseBtn = document.getElementById('cookie-settings-close');
  var settingsDeclineBtn = document.getElementById('cookie-settings-decline');
  var settingsSaveBtn = document.getElementById('cookie-settings-save');

  var preferencesCheckbox = document.getElementById('cookie-preferences');
  var marketingCheckbox = document.getElementById('cookie-marketing');
  var analyticsCheckbox = document.getElementById('cookie-analytics');

  // Check if Shopify Customer Privacy API is available
  function getShopifyPrivacy() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) {
      console.warn('[Pawmate Cookie] Shopify.customerPrivacy not available yet');
    }
    return privacy;
  }

  // Check if consent already given via Shopify API
  function hasConsent() {
    var privacy = getShopifyPrivacy();
    if (privacy && typeof privacy.shouldShowBanner === 'function') {
      return !privacy.shouldShowBanner();
    }
    // Fallback: check localStorage
    try {
      return localStorage.getItem('pawmate_cookie_consent') !== null;
    } catch (e) {
      return false;
    }
  }

  // Get current consent from Shopify API
  function getCurrentConsent() {
    var privacy = getShopifyPrivacy();
    if (privacy && typeof privacy.currentVisitorConsent === 'function') {
      return privacy.currentVisitorConsent();
    }
    return null;
  }

  // Save consent to Shopify Customer Privacy API
  function saveConsent(preferences, action) {
    console.log('[Pawmate Cookie] saveConsent called:', action, preferences);

    // Update global consent state and activate blocked scripts
    window.pawmateConsent.updateState(preferences);

    // Use the setShopifyConsent with retry logic
    setShopifyConsent(preferences);

    // Save to localStorage with version marker
    try {
      localStorage.setItem('pawmate_cookie_consent', 'set');
      localStorage.setItem('pawmate_cookie_preferences', JSON.stringify({
        ...preferences,
        _version: '2.0'
      }));
    } catch (e) {
      // Ignore localStorage errors
    }

    // Log consent for GDPR audit trail
    logConsent(action || 'custom', preferences);

    // Dispatch custom event for other scripts
    window.dispatchEvent(new CustomEvent('pawmate:cookie-consent', {
      detail: { preferences: preferences }
    }));
  }

  // Log consent to localStorage for GDPR compliance
  function logConsent(action, preferences) {
    try {
      var log = {
        timestamp: new Date().toISOString(),
        action: action,
        categories: preferences,
        url: window.location.pathname
      };

      var history = [];
      try {
        history = JSON.parse(localStorage.getItem('pawmate_consent_history') || '[]');
      } catch (e) {}
      history.push(log);
      // Keep last 10 entries
      if (history.length > 10) history = history.slice(-10);
      localStorage.setItem('pawmate_consent_history', JSON.stringify(history));
    } catch (e) {
      // Silent fail
    }
  }

  // Helper to set Shopify consent with retry
  function setShopifyConsent(prefs, retryCount) {
    retryCount = retryCount || 0;
    var privacy = getShopifyPrivacy();

    if (privacy && typeof privacy.setTrackingConsent === 'function') {
      console.log('[Pawmate Cookie] Calling Shopify setTrackingConsent with:', prefs);
      privacy.setTrackingConsent({
        analytics: prefs.analytics,
        marketing: prefs.marketing,
        preferences: prefs.preferences,
        sale_of_data: prefs.marketing
      }, function(result) {
        console.log('[Pawmate Cookie] Shopify consent saved successfully:', prefs, result);
      });
    } else if (retryCount < 5) {
      console.warn('[Pawmate Cookie] Shopify API not ready, retry #' + (retryCount + 1));
      // Retry up to 5 times with increasing delay
      console.warn('Shopify customerPrivacy not ready, retry #' + (retryCount + 1));
      setTimeout(function() {
        setShopifyConsent(prefs, retryCount + 1);
      }, 300 * (retryCount + 1));
    } else {
      console.error('Failed to set Shopify consent after 5 retries');
    }
  }

  // Show banner with slide-up animation
  function showBanner() {
    if (!banner) return;
    // Remove inline hidden styles
    banner.style.display = 'block';
    banner.style.opacity = '';
    banner.style.visibility = '';
    banner.setAttribute('aria-hidden', 'false');
    banner.offsetHeight; // Trigger reflow
    requestAnimationFrame(function() {
      banner.classList.add('is-visible');
    });
  }

  // Hide banner
  function hideBanner() {
    if (!banner) return;
    // Remove focus before hiding to avoid aria-hidden warning
    if (document.activeElement && banner.contains(document.activeElement)) {
      document.activeElement.blur();
    }
    banner.classList.remove('is-visible');
    banner.setAttribute('aria-hidden', 'true');
    setTimeout(function() {
      banner.style.display = 'none';
    }, 400);
  }

  // Show settings modal
  function showSettings() {
    // Load current consent into checkboxes
    var consent = getCurrentConsent();
    if (consent) {
      preferencesCheckbox.checked = consent.preferences === 'yes';
      marketingCheckbox.checked = consent.marketing === 'yes';
      analyticsCheckbox.checked = consent.analytics === 'yes';
    }

    // Remove inline hidden styles
    settingsOverlay.style.display = 'block';
    settingsOverlay.style.opacity = '';
    settingsOverlay.style.visibility = '';
    settingsModal.style.display = 'block';
    settingsModal.style.opacity = '';
    settingsModal.style.visibility = '';

    settingsOverlay.setAttribute('aria-hidden', 'false');
    settingsModal.setAttribute('aria-hidden', 'false');

    requestAnimationFrame(function() {
      settingsOverlay.classList.add('is-visible');
      settingsModal.classList.add('is-visible');
    });

    settingsCloseBtn.focus();
    document.body.style.overflow = 'hidden';
  }

  // Hide settings modal
  function hideSettings() {
    settingsOverlay.classList.remove('is-visible');
    settingsModal.classList.remove('is-visible');
    settingsOverlay.setAttribute('aria-hidden', 'true');
    settingsModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Accept all cookies
  function acceptAll() {
    saveConsent({
      analytics: true,
      marketing: true,
      preferences: true
    }, 'accept_all');
    hideBanner();
    hideSettings();
  }

  // Decline optional cookies - strict GDPR mode (all optional cookies OFF)
  function declineOptional() {
    saveConsent({
      analytics: false,
      marketing: false,
      preferences: false
    }, 'decline_optional');
    hideBanner();
    hideSettings();
  }

  // Save custom preferences from modal checkboxes
  function saveCustomPreferences() {
    saveConsent({
      analytics: analyticsCheckbox.checked,
      marketing: marketingCheckbox.checked,
      preferences: preferencesCheckbox.checked
    }, 'custom');
    hideBanner();
    hideSettings();
  }

  // Expose showSettings globally for footer link
  window.pawmateCookieSettings = showSettings;

  // Event listeners
  if (acceptBtn) acceptBtn.addEventListener('click', acceptAll);
  if (declineBtn) declineBtn.addEventListener('click', declineOptional);
  if (settingsBtn) settingsBtn.addEventListener('click', showSettings);
  if (settingsCloseBtn) settingsCloseBtn.addEventListener('click', hideSettings);
  if (settingsOverlay) settingsOverlay.addEventListener('click', hideSettings);
  if (settingsDeclineBtn) settingsDeclineBtn.addEventListener('click', declineOptional);
  if (settingsSaveBtn) settingsSaveBtn.addEventListener('click', saveCustomPreferences);

  // Escape key to close settings
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && settingsModal && settingsModal.classList.contains('is-visible')) {
      hideSettings();
    }
  });

  // Check if old consent needs migration (pre-v2.0)
  function needsMigration() {
    try {
      var prefs = JSON.parse(localStorage.getItem('pawmate_cookie_preferences') || '{}');
      // Old version had analytics forced to true without _version marker
      return prefs.analytics === true && typeof prefs._version === 'undefined';
    } catch (e) {
      return false;
    }
  }

  // Initialize: wait for Shopify API to be ready
  function init() {
    var localConsent = false;
    try {
      localConsent = localStorage.getItem('pawmate_cookie_consent') !== null;
    } catch (e) {}

    // Migration: old consent without granular analytics choice → force re-consent
    if (localConsent && needsMigration()) {
      try {
        localStorage.removeItem('pawmate_cookie_consent');
        localStorage.removeItem('pawmate_cookie_preferences');
        localConsent = false;
      } catch (e) {}
    }

    // Load existing consent into global state AND tell Shopify API
    if (localConsent) {
      try {
        var prefs = JSON.parse(localStorage.getItem('pawmate_cookie_preferences') || '{}');
        var consentState = {
          analytics: prefs.analytics || false,
          marketing: prefs.marketing || false,
          preferences: prefs.preferences || false
        };
        window.pawmateConsent.updateState(consentState);
        // CRITICAL: Also inform Shopify API so pixels can load!
        setShopifyConsent(consentState);
      } catch (e) {}
    } else {
      // No consent yet - show banner and wait for user choice
      // (Shopify defaults to blocked state until consent given)
      setTimeout(showBanner, 800);
    }
  }

  // Load Shopify Customer Privacy API properly
  function loadShopifyPrivacy(callback) {
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([
        { name: 'consent-tracking-api', version: '0.1' }
      ], function(error) {
        if (error) {
          console.error('Failed to load Shopify consent API:', error);
        }
        callback();
      });
    } else {
      // Fallback: wait for Shopify to be available
      if (document.readyState === 'complete') {
        callback();
      } else {
        window.addEventListener('load', callback);
      }
    }
  }

  // Start initialization after Shopify API is loaded
  loadShopifyPrivacy(init);

  // Also listen for Shopify's privacy API ready event
  // BUT only hide if we actually have consent in localStorage
  document.addEventListener('visitorConsentCollected', function() {
    try {
      if (localStorage.getItem('pawmate_cookie_consent') !== null) {
        hideBanner();
      }
    } catch (e) {}
  });
})();
